import { styled } from "@mui/material/styles";

export const StyledKeyAssetTypeSectionContainer = styled("div")(
  ({ theme }) => ({
    padding: "18px 0"
  })
);
